<template>
  <div class="infoPublicityRightBox">
    <el-card class="bannerCard">
      <div slot="header" class="clearfix">
        <span class="headerTitle">{{inforStr}}</span>
        <el-button class="refreshBtn" @click="handleRefresh" type="text">换一批<i class="el-icon-refresh"></i></el-button>
      </div>
      <div v-for="(item,index) in tableData" :key="index" class="consult" @click="handleDetail(item.id)">
        <span class="itemIndex">{{index+1}}</span><span v-if="receiveType == 1">{{item.publicityTitle}}</span>
        <span v-if="receiveType == 2">{{item.newsTitle }}</span>
      </div>
      <el-button class="moreBtn" type="text" @click="handlMore">更多<i class="el-icon-d-arrow-right"></i></el-button>
    </el-card>
  </div>
</template>
<script>
import Bus from '@/js/bus.js'
export default {
  data() {
    return {
      tableData: [],
      inforStr: '',
      currentPage: 1,
      tableLength: 0,
      receiveType: '',

    }
  },
  created() {
    this.receiveType = this.$route.query.type;
    if (this.$route.query.type == 1) {
      this.getPublicity();
      this.inforStr = '版权公示';
    } else {
      this.getConsult();
      this.inforStr = '最新资讯';
    }
  },
  mounted() {
    let that = this;
    Bus.$on('handleDetailsRight', (type) => {
      that.receiveType = type
      if (that.receiveType == 1) {
        that.getPublicity();
        that.inforStr = '版权公示';
      } else {
        that.getConsult();
        that.inforStr = '最新资讯';
      }
    })
  },
  methods: {
    handleDetail(id) {
      let type
      if (this.receiveType == 1) {
        type = 2;
      } else {
        type = 1;
      }
      Bus.$emit('handleDetails', id, type)
    },
    handlMore() {
      let type
      if (this.receiveType == 1) {
        type = 2;
      } else {
        type = 1;
      }
      this.$router.push({
        path: '/infoPublicity',
        query: {
          type: type
        }
      })

    },
    handleRefresh() {
      this.currentPage = this.currentPage + 1;
      if (this.tableLength != 8) {
        this.currentPage = 1;
      }
      if (this.receiveType == 1) {
        this.getPublicity();
      } else {
        this.getConsult();
      }

    },
    //资讯列表
    getConsult() {
      this.$axiosPost(this.$store.state.assets_url + "/wespace/index/findWorksNews", {
        currentPage: this.currentPage,
        pageSize: '8'
      }).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.list;
          this.tableLength = this.tableData.length;
        }
      })
    },
    //公示列表
    getPublicity() {
      this.$axiosGet(this.$store.state.asset_public + "publicity/info/list", {
        status: 1,
        usn: this.$store.state.userData ? (this.$store.state.userData.usn ? this.$store.state.userData.usn : '') : '',
        type: 5,
        publicityExamineStatus: 2,
        currentPage: this.currentPage,
        pageSize: 8,

      }).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data.list;
          this.tableLength = this.tableData.length;
        }
      });
    }
  }
}
</script>
<style scoped lang="scss">
.infoPublicityRightBox {
  .bannerCard {
    width: 287px;
    box-shadow: 0px 2px 4px 0px rgba(153, 153, 153, 0.1);
    border: none;

    .headerTitle {
      font-size: 16px;
      font-weight: 600;
      font-weight: bold;
      color: #181818;
    }
    .refreshBtn {
      float: right;
      color: #999999;
      padding: 0;
      position: relative;
      margin-right: 25px;
      display: inline-block;
      .el-icon-refresh {
        font-size: 20px;
        position: absolute;
        right: -25px;
        top: -2.5px;
        cursor: pointer;
      }
    }
    .consult {
      line-height: 42px;
      height: 42px;
      color: #333;
      display: -webkit-box; //谷歌
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; //显示几行
      word-wrap: break-word;
      overflow: hidden;
      border-bottom: 1px solid #f2f2f2;
      font-size: 15px;
      font-weight: 900;
      font-weight: bold;
      .itemIndex {
        display: inline-block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        background: #1C77FF;
        color: #ffffff;
        text-align: center;
        margin-right: 8px;
      }
    }
    .consult:last-child {
      border-bottom: none;
    }
    .consult:hover {
      color: #1C77FF;
      cursor: pointer;
    }
    .moreBtn {
      display: inline-block;
      color: #999999;
      padding: 0;
      position: relative;
      margin-right: 25px;
      margin: 9px 0 13px 104px;
      text-align: center;
      color: #1C77FF;
      cursor: pointer;
      .el-icon-d-arrow-right {
        font-size: 14px;
        position: absolute;
        right: -20px;
        top: -0;
      }
    }
  }
  ::v-deep.el-card__body {
    padding: 0 12px 0 13px;
  }
}
</style>
